import { useQuery, useMutation, } from "@tanstack/react-query";
export const createContestsEditionsJudgesQueries = (requests, queryClient) => ({
    useCreateContestsEditionJudge: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionJudgeAttrs) => {
            return requests.createContestsEditionJudge(contestsEditionJudgeAttrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-judges"],
            });
            options.onSuccess?.(...args);
        },
    }),
    useInviteContestsEditionJudge: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionJudgeAttrs) => {
            return requests.inviteContestsEditionJudge(contestsEditionJudgeAttrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-judges"],
            });
            options.onSuccess?.(...args);
        },
    }),
    useJoinContestsEditionByCode: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionJudgeAttrs) => {
            return requests.joinContestsEditionByCode(contestsEditionJudgeAttrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-judges"],
            });
            options.onSuccess?.(...args);
        },
    }),
    useApproveContestsEditionJudge: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionJudgeAttrs) => {
            return requests.approveContestsEditionJudge(contestsEditionJudgeAttrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-judges"],
            });
            options.onSuccess?.(...args);
        },
    }),
    useListContestsEditionsJudges: (params, options = {}) => useQuery({
        queryKey: ["contests-editions-judges", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listContestsEditionJudges(params);
        },
        ...options,
    }),
    useFindContestsEditionJudge: (params, options = {}) => useQuery({
        queryKey: ["contests-editions-judges", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findContestsEditionJudge(params);
        },
        ...options,
    }),
    useContestsEditionJudgeStats: (params, options = {}) => useQuery({
        queryKey: ["contests-editions-judges-stats", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.contestsEditionJudgeStats(params);
        },
        ...options,
    }),
    useRejectContestsEditionJudge: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionJudgeAttrs) => {
            return requests.rejectContestsEditionJudge(contestsEditionJudgeAttrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-judges"],
            });
            options.onSuccess?.(...args);
        },
    }),
    useToggleJudgePresence: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionJudgeAttrs) => {
            return requests.toggleJudgePresence(contestsEditionJudgeAttrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-judges"],
            });
            options.onSuccess?.(...args);
        },
    }),
});
//# sourceMappingURL=index.js.map